import script from "./Honor.vue?vue&type=script&setup=true&lang=js"
export * from "./Honor.vue?vue&type=script&setup=true&lang=js"

import "./Honor.vue?vue&type=style&index=0&id=5d418454&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d418454"]])

export default __exports__